import { render, staticRenderFns } from "./ReturnedAdmin.vue?vue&type=template&id=41a308ec&scoped=true&"
import script from "./ReturnedAdmin.vue?vue&type=script&lang=js&"
export * from "./ReturnedAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ReturnedAdmin.vue?vue&type=style&index=0&id=41a308ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a308ec",
  null
  
)

export default component.exports